import renderMenu from "./renderMenu";
import toggleMenu from "./toggleMenu";
import translateWidget from "./translateWidget";

export let $menu: HTMLElement | undefined;

export function openMenu() {
    if($menu) {
        toggleMenu();
    } else {
        $menu = renderMenu();
        const widgetContainer = document.querySelector('#cya11y-container');
        const btn = widgetContainer?.shadowRoot?.querySelector('.cya11y-menu-btn') as HTMLElement | null;
        btn?.setAttribute('aria-controls', 'cya11y-accessibility-menu');
    }

    translateWidget($menu);
}